import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserGroupUnsubscribe($code: String!){
        user_group_unsubscribe(code: $code) {
            success
        }
    }
`;

export async function userGroupUnsubscribe(code: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ user_group_unsubscribe: { success: boolean } }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { code },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_group_unsubscribe;
}
